<p-dialog
  [(visible)]="displayAdditionalInfoModal"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayAdditionalInfoModal = false"
  [style]="{ width: '700px' }"
>
  <div style="padding: 40px 80px">
    <div class="modal__wrapper">
      <div class="flex flex-justify-center flex-flow-wrap flex-align-end">
        <h4 class="modal-title">{{ 'AUTH.we_need_info' | translate }}</h4>
        <p class="mt-1 mb-1 text--size-2 ml-2">
          {{ 'AUTH.fill_fields_for_create_project' | translate }}
        </p>
      </div>
      <div class="flex flex-cols-2" *ngIf="shouldShowInput('profile_name')">
        <app-ph-input
          [placeholder]="'ACCOUNT.profile_name' | translate"
          [validation]="'namesurnamereq'"
          [showRequired]="true"
          type="text"
          name="name"
          [correctForm]="form"
          [initValue]="storage.user ? storage.user.name : ''"
        ></app-ph-input>
        <app-ph-input
          [placeholder]="'ACCOUNT.profile_surname' | translate"
          [validation]="'namesurnamereq'"
          [showRequired]="true"
          type="text"
          name="surname"
          [correctForm]="form"
          [initValue]="storage.user ? storage.user.surname : ''"
        ></app-ph-input>
      </div>
      <app-ph-input
        *ngIf="shouldShowInput('your_email')"
        [placeholder]="'FORMS.your_email' | translate"
        [showRequired]="!storage.user"
        [validation]="'email'"
        type="email"
        name="email"
        [correctForm]="form"
        [initValue]="storage.user ? storage.user.surname : ''"
      ></app-ph-input>
      <div *ngIf="shouldShowInput('personal_information')" class="form-section-title">
        {{ 'ACCOUNT.personal_information' | translate }}
      </div>
      <div *ngIf="shouldShowInput('profile_country')" class="flex flex-cols--nationality">
        <app-ph-input
          [placeholder]="'ACCOUNT.profile_country' | translate"
          [clearable]="!!storage.user"
          [validation]="'empty'"
          [showRequired]="false"
          type="select"
          bindValue="code"
          name="tax_residence"
          [selectArray]="countries"
          bindLabel="name"
          [correctForm]="form"
          [initValue]="storage.user ? storage.user.tax_residence : 'PL'"
        ></app-ph-input>
        <app-ph-input
          [placeholder]="'ACCOUNT.profile_nationality' | translate"
          [clearable]="!!storage.user"
          [validation]="'empty'"
          [showRequired]="false"
          type="select"
          bindValue="code"
          name="origin_country"
          [selectArray]="countries"
          bindLabel="name"
          [correctForm]="form"
          [initValue]="storage.user ? storage.user.origin_country : 'PL'"
        ></app-ph-input>
      </div>
      <div *ngIf="shouldShowInput('birthday')" class="form-section-title form-section-title--light">
        {{ 'ACCOUNT.birthday' | translate }}
      </div>
      <div *ngIf="shouldShowInput('birthday')" class="date-time-select">
        <div class="date-time-select__item">
          <app-ph-input
            [placeholder]="'FORMS.date_day' | translate"
            [clearable]="false"
            [searchable]="false"
            [validation]="'empty'"
            [showRequired]="false"
            type="select"
            bindValue="value"
            name="day"
            [selectArray]="days"
            bindLabel="id"
            [correctForm]="form"
            [disabled]="
              storage.user &&
              (storage.user.kyc_lvl === 'KYC_SUCCEEDED' ||
                storage.user.kyc_lvl === 'VALIDATION_ASKED')
            "
            [initValue]="storage.user ? (storage.user.birthday ? userBirthDay : 1) : 1"
          ></app-ph-input>
        </div>
        <div class="date-time-select__item">
          <app-ph-input
            [placeholder]="'FORMS.date_month' | translate"
            [clearable]="false"
            [searchable]="false"
            [validation]="'empty'"
            [showRequired]="false"
            type="select"
            bindValue="value"
            name="month"
            [selectArray]="months"
            (phInputChange)="
              onMonthSelect($event, form.get('year').value ? form.get('year').value : 1920)
            "
            bindLabel="name"
            [correctForm]="form"
            [disabled]="
              storage.user &&
              (storage.user.kyc_lvl === 'KYC_SUCCEEDED' ||
                storage.user.kyc_lvl === 'VALIDATION_ASKED')
            "
            [initValue]="storage.user ? (storage.user.birthday ? userBirthMonth : 1) : 1"
          ></app-ph-input>
        </div>
        <div class="date-time-select__item">
          <app-ph-input
            [placeholder]="'FORMS.date_year' | translate"
            [clearable]="false"
            [searchable]="false"
            [validation]="'empty'"
            [showRequired]="false"
            type="select"
            bindValue="value"
            name="year"
            [selectArray]="years"
            bindLabel="id"
            (phInputChange)="onYearSelect($event)"
            [correctForm]="form"
            [disabled]="
              storage.user &&
              (storage.user.kyc_lvl === 'KYC_SUCCEEDED' ||
                storage.user.kyc_lvl === 'VALIDATION_ASKED')
            "
            [initValue]="storage.user ? (storage.user.birthday ? userBirthYear : 1990) : 1990"
          ></app-ph-input>
        </div>
      </div>
      <app-ph-input
        class="checkbox"
        *ngIf="!storage.user"
        [validation]="'checkbox'"
        type="checkbox"
        [showRequired]="true"
        name="privacy_policy"
        [correctForm]="form"
        [initValue]="false"
      >
        {{ 'ACCOUNT.i_accept' | translate }}
        <a
          class="text--primary-light text-decoration"
          [routerLink]="'/' + RoutesPath.default.terms"
          (click)="$event.stopPropagation()"
          target="_blank"
        >
          {{ 'FOOTER.terms_conditions' | translate }}
          {{ 'GLOBAL.and' | translate }}
        </a>
        <a
          class="text--primary-light text-decoration"
          [routerLink]="'/' + RoutesPath.default.privacy"
          (click)="$event.stopPropagation()"
          target="_blank"
        >
          {{ 'FOOTER.privacy_policy' | translate }}</a
        >
      </app-ph-input>
      <app-ph-input
        class="checkbox"
        type="checkbox"
        [validation]="'checkbox'"
        name="mail_notifications"
        (phInputChange)="toggleMailNotif()"
        [initValue]="false"
      >
        {{ 'ACCOUNT.email_notifications' | translate }}
      </app-ph-input>
    </div>
    <div class="flex flex-justify-center flex-flow-wrap flex-align-end">
      <button class="btn btn--outline btn--md mt-1 mb-2 mr-2" (click)="closeModal()">
        {{ 'GLOBAL.cancel' | translate }}
      </button>
      <button
        class="btn btn--primary btn--md mt-1 mb-2 ml-2"
        [disabled]="form.invalid || disabled"
        (click)="updateProfile()"
      >
        {{ 'GLOBAL.save_continue' | translate }}
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="displayDeleteModal"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayDeleteModal = false; onDeleteModal()"
>
  <div style="padding: 40px 80px">
    <div class="modal__wrapper">
      <div class="modal__title">
        {{ 'ACCOUNT.are_you_sure_delete_acc' | translate }}
      </div>
      <div class="modal__description">
        {{ 'ACCOUNT.delete_acc_desc' | translate }}
      </div>
      <div class="modal__actions">
        <button class="btn btn--outline btn--md mw-160" (click)="displayDeleteModal = false">
          {{ 'GLOBAL.cancel' | translate }}
        </button>
        <button
          class="btn btn--danger btn--md mw-160"
          (click)="displayConfirmDeleteModal = true; displayDeleteModal = false"
        >
          {{ 'ACCOUNT.delete_acc' | translate }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="displayConfirmDeleteModal"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayConfirmDeleteModal = false; onDeleteModal()"
>
  <div style="padding: 40px 80px">
    <div class="modal__wrapper">
      <div class="modal__title" *ngIf="!socialUserInfo">
        {{ 'ACCOUNT.delete_acc_pass' | translate }}
      </div>
      <div class="modal__title" *ngIf="socialUserInfo">
        {{ 'ACCOUNT.delete_acc_pass_social' | translate }}
      </div>
      <div class="modal__description">
        {{ 'ACCOUNT.delete_acc_desc' | translate }}
      </div>
      <div class="modal__form" *ngIf="!socialUserInfo">
        <app-ph-input
          [placeholder]="'ACCOUNT.password' | translate"
          [validation]="'required'"
          [correctForm]="formConfirmAccountDelete"
          (keyUpEnter)="deleteAccount()"
          name="plain_password"
          type="password"
        ></app-ph-input>
      </div>
      <div class="modal__actions">
        <button class="btn btn--outline btn--md mw-160" (click)="displayConfirmDeleteModal = false">
          {{ 'GLOBAL.cancel' | translate }}
        </button>
        <button
          class="btn btn--danger btn--md mw-160"
          [disabled]="loading || formConfirmAccountDelete.invalid"
          (click)="deleteAccount()"
        >
          {{ 'ACCOUNT.delete_acc' | translate }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>
